<template>
  <div>
    <div class="top-1 bg-transparent " style="margin-top: 3%;overflow: auto">
      <table style="width: 100%;">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="layers.placementlayers.length > 0"><td colspan="6">{{$t("placement")}}</td></tr>
          <tr v-for="(layer, index) in layers.placementlayers" :key="layer.name">
            <th><input type="checkbox" :id="layer.name" :value="layer.name" v-model="layer.checked" :title="tooltipHideShowLayer" @change="check(layer)"></th>
            <th class="text-left">
              <label for="layer.name">{{ layer.name }}</label></th> 
          </tr>
          <tr v-for="(layer, index) in layers.measurementlayers" :key="layer.name">
            <th><input type="checkbox" :id="layer.name" :value="layer.name" v-model="layer.checked" :title="tooltipHideShowLayer" @change="check(layer)"></th>
            <th class="text-left">
              <label for="layer.name">{{ layer.name }}</label></th> 
          </tr>
          <tr v-for="(layer, index) in layers.maplayers" :key="layer.name">
            <th><input type="checkbox" :id="layer.name" :value="layer.name" v-model="layer.checked" :title="tooltipHideShowLayer" @change="check(layer)"></th>
            <th class="text-left">
              <label for="layer.name">{{ layer.name }}</label></th> 
            <th><span @click="remove(layer)"><font-awesome-icon icon="minus-square" :title="tooltipRemoveLayer" class="text-pastel-red"/></span></th>
            <th>
              <span @click="download(layer)"><font-awesome-icon icon="arrow-circle-down" :title="tooltipDownloadImg" class="text-green-400" />
              </span>
            </th>
          </tr>
          <tr v-if="waitingforfanspeed"><td colspan="6">{{$t("waitingforfanspeed")}}</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import GeoserverHelper from '../../../helpers/geoserver' 


export default {
name: 'Layers',
props: [
  "layers",
  "waitingforfanspeed"
],
methods: {
  check: function(e) {
    this.$emit("checklayer",e);
  },
  remove : function(e) {
    this.$emit('removelayer', e);
  },
  download : function(e) {
    GeoserverHelper.downloadmapimage(e.selections);
  },
},
computed:{
  tooltipRemoveLayer: function(){
    return this.$t('tooltipRemoveLayer')
  },
  tooltipDownloadImg: function(){
    return this.$t('tooltipDownloadImg')
  },
  tooltipHideShowLayer: function(){
    return this.$t('tooltipHideShowLayer')
  },
}
};
</script>


